import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z","key":"svg-0"}]]

const IconSquareRounded = createReactComponent('outline', 'square-rounded', 'SquareRounded', __iconNode);

export default IconSquareRounded;